import { tnoSecondaryDark, tnoSecondaryLight } from './tnoBrandColors';

export const light = {
  alternate: {
    main: '#f7f3fc',
    dark: '#eee6f8',
  },
  cardShadow: 'rgba(106, 27, 154, .11)',
  mode: 'light',
  primary: {
    main: '#8e24aa',
    light: '#ab47bc',
    dark: '#6a1b9a',
    contrastText: '#fff',
  },
  secondary: { ...tnoSecondaryLight },
  text: {
    primary: '#2d3748',
    secondary: '#646e73',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
  },
};

export const dark = {
  alternate: {
    main: '#21182d',
    dark: '#1a1324',
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  mode: 'dark',
  primary: {
    main: '#ab47bc',
    light: '#ba68c8',
    dark: '#6a1b9a',
    contrastText: '#fff',
  },
  secondary: { ...tnoSecondaryDark },
  text: {
    primary: '#eeeeef',
    secondary: '#aeb0b4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#222b45',
    default: '#222b45',
    level2: '#333',
    level1: '#2d3748',
  },
};
